/**
 * en-GB messages added by Phase 2 task M3 (docs/PHASE-2-PLAN.md). Only that task edits this file.
 * Flat keys, `{name}` placeholders, merged into enGB by ./index.ts.
 */
export const m3EnGB = {
    // Notification buttons and the short confirmation after pressing one
    'companion.push.action_on_my_way': 'On my way',
    'companion.push.action_please_wait': 'Please wait',
    'companion.push.action_running_late': 'Running late',
    'companion.push.action_cancelled': 'Cancelled',
    'companion.push.result_sent': 'Reply sent',
    'companion.push.result_queued': 'No connection. Your reply will be sent when you are back online.',
    'companion.push.result_failed': 'Your reply could not be sent. Open the app to try again.',
    // Location (sign in and out when you arrive at or leave a site)
    'companion.location.title': 'Sign in by location',
    'companion.location.notice': 'If you agree, CloudSign can sign you in when you arrive at your site and out when you leave. Your phone works out when you arrive or leave; your position is not sent to CloudSign. It watches only the area around your site, only while you have agreed, and it stops straight away if you withdraw.',
    'companion.location.agree': 'I agree',
    'companion.location.given': 'You have agreed.',
    'companion.location.not_given': 'You have not agreed.',
    'companion.location.withdraw': 'Withdraw my agreement',
    'companion.location.explain_title': 'Before your phone asks',
    'companion.location.explain_body': 'Your phone will now ask to use your location, and then to allow it all the time. This is so CloudSign can notice you arriving or leaving even when the app is closed. You can say no, and then nothing will happen.',
    'companion.location.continue': 'Continue',
    'companion.location.running': 'On. CloudSign is watching: {site}.',
    'companion.location.needs_permission': 'You have agreed, but your phone has not allowed location all the time, so nothing is happening yet.',
    'companion.location.open_settings': 'Open phone settings',
    'companion.location.try_again': 'Ask again',
    'companion.location.denied': 'Your phone did not allow location all the time, so signing in by location is not working. You can change this in your phone settings.',
    'companion.location.channel': 'Location in use',
    'companion.location.notice_title': 'CloudSign is using your location',
    'companion.location.notice_body': 'CloudSign is using your location to sign you in at {site}.',
};
//# sourceMappingURL=m3.js.map